import { Serializable } from "../utilities/Serializable";
import { Zone } from "./Zone";

export class PriceList extends Serializable {
    uuid: string;
    name: string;
    startDate: string;
    endDate: string;
    zone: Zone;
}


// WEBPACK FOOTER //
// ./src/app/models/Pricelist.ts